import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, IncidenciaUsuarioCategoria, SearchIncidenciaUsuarioCategoriaRequest, SearchIncidenciaUsuarioCategoriaResponse, SaveIncidenciaUsuarioCategoriaDto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class IncidenciaUsuarioCategoriaService extends CrudService<IncidenciaUsuarioCategoria, number, SaveIncidenciaUsuarioCategoriaDto, SearchIncidenciaUsuarioCategoriaRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'IncidenciaUsuarioCategoria', sharedFunctions);

  }

  getSubCategorias(menuPadreId:number): Observable<GenericResponse<IncidenciaUsuarioCategoria[]>> {
    return this._http.get<GenericResponse<IncidenciaUsuarioCategoria[]>>(this._serviceUrl + '/SubCategoria/' + menuPadreId, this.httpOptions);
  }

}